module.exports = __webpack_public_path__ + "static/img/Andrew-Ettingshausen.25d0e07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-Ettingshausen.jpg
// module id = Ndr+
// module chunks = 0